module.exports = __webpack_public_path__ + "img/logo-title-w.2149e1fc.svg";